import { getTag } from "@/data/library";

/** All of a post's tags as small chips. Rendered inside card links, so these
 *  are plain spans — the tag pages are reachable from the post page itself. */
export const TagChips = ({ tags }: { tags: string[] }) => (
  <span className="flex flex-wrap gap-1.5">
    {tags.map((slug) => {
      const tag = getTag(slug);
      if (!tag) return null;
      return (
        <span
          key={slug}
          className="text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 border border-border rounded text-muted-foreground"
        >
          {tag.name}
        </span>
      );
    })}
  </span>
);
